//dependencies
import React from "react";

// components
import Chip, { ChipProps } from "../..";

/**
 * @deprecated
 */
const SmallChip: React.FC<Omit<ChipProps, "padding">> = (props) => {
	return <Chip labelProps={{ size: "caption" }} {...props} innerStyle={{ ...props.innerStyle, padding: 2 }} />;
};

export default SmallChip;
